import React from 'react'
import {Button, Header, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import {useSelector} from "react-redux";
import { createUserLog } from '../../lib/api';

const FuelProps =({tags, channel,title, parentCallback, data, setDataCopy}) => {

    const [toggle, setToggle] = React.useState();
    const [open,setOpen]= React.useState(false);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleToggle =(event, {id}) => {
        setToggle(id);
        event.preventDefault();
        if(id === '1') {
            let tag_arr = [];
            tag_arr.push(tags);
            var adiodata = {'buttonClickType': channel, 'tags': tag_arr};
            socket.emit('button click', adiodata);

            //update SOFC for test 
            // setDataCopy({...data});

            setOpen(false);
            if (!electronApp) {
                let log = {
                    user_id: user.id,
                    powerplant_id: ppid,
                    display_id: null,
                    datetime: new Date().toISOString(),
                    data: JSON.stringify({ tag_id: tag_arr, type: channel }),
                };
                createUserLog({ log }).catch(console.error);
            }
            parentCallback(true);
        }
        else if(id === '2'){
            setOpen(false);
        }
    }

    return (
        <div>
            <Modal trigger = {<Button color = 'blue'>{title} </Button>}
                   style = {styles.toggle}
                   open = {open}
                   onClose={handleClose}
                   onOpen={handleOpen}>
                <Modal.Header>Confirmation</Modal.Header>
                <Modal.Description>
                    <Header style = {styles.header}> Do you want to {channel}?</Header>
                </Modal.Description>
                <Modal.Actions>
                    <Button color={'green'}
                            size='small'
                            id = '1'
                            active={toggle ==='1'}
                            content='OK'
                            onClick={handleToggle}
                    />
                    <Button color={'red'}
                            size='small'
                            id = '2'
                            active={toggle==='2'}
                            content='Cancel'
                            onClick={handleToggle}
                    />
                </Modal.Actions>
            </Modal>
        </div>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px'
    }
}

export default FuelProps;